import { useState, useEffect } from "react";
import "../../components/LeadDataReport/LeadDataReport.css";
import axios from "axios";
import ExcelExport from "../ExcelExport/ExcelExport";
import filterIcon from "../../Icons/filterIcon.png";
import showDoc from "../../images/showDoc.svg";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import "./PettyCash.css";
import CryptoJS from "crypto-js";

const PettyCash = () => {
  const [leadResponse, setLeadResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [expenseType, setExpenseType] = useState([]);
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [pettyCashListResponse, setPettyCashListResponse] = useState([]);

  function nextPage(pettycash_id) {
    const encryptedId = CryptoJS.AES.encrypt(
      pettycash_id.toString(),
      "dbbworldwidepvtltd",
    ).toString();
    const url = `/ViewPettyCashDetail?id=${encodeURIComponent(encryptedId)}`;
    window.open(url, "_blank");
  }

  function getStatusColor(status) {
    switch (status) {
      case "Pending":
        return "#0DCAF0";
      case "Requested":
        return "#F19C00";
      case "Rejected":
        return "#DC3545";
      case "Completed":
        return "#20BF44";
    }
  }

  useEffect(() => {
    fetchPettyCashList();
  }, []);

  const fetchPettyCashList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const pcDetailRes = await axios.get(
        `${baseAPI}userGet/GetPettyCashDetail?pettycash_id=0&relocation_id=0`,
        { headers },
      );
      setPettyCashListResponse(pcDetailRes.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "20px",
        }}
      >
        <button className="filterButton">
          <img src={filterIcon} /> FILTER
        </button>
        <div style={{ display: "flex" }}>
          <ExcelExport leadResponse={leadResponse} />
        </div>
      </div>

      <div className="headingLeadReport">
        <p>Petty Cash List</p>
      </div>
      <div
        className="container-fluid"
        style={{ width: "100%", overflowX: "auto" }}
      >
        <div className="petBreedList">
          <table>
            <thead>
              <tr
                className="petBreedListHeading"
                style={{
                  whiteSpace: "nowrap",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <th>Sr. No</th>
                <th>Receipt Number</th>
                <th>Lead ID</th>
                <th>Name</th>
                <th>Date of Request</th>
                <th>Request Type</th>
                <th>Purpose</th>
                <th>Requested Amount</th>
                <th>Payment Status</th>
                <th>Action</th>
                {/* <th>Document</th> */}
              </tr>
            </thead>
            <tbody>
              {pettyCashListResponse && pettyCashListResponse.length > 0
                ? pettyCashListResponse.map((item, idx) => {
                    return (
                      <tr>
                        <td>{idx + 1}</td>
                        <td>{item.pettycash_id}</td>
                        <td>{item.relocation_id}</td>
                        <td>{item.requested_by_name}</td>
                        <td>{item.request_date}</td>
                        <td>{item.request_type_name}</td>
                        <td>{item.remark}</td>
                        <td>{item.amount}</td>
                        <td>
                          <button
                            style={{
                              backgroundColor: getStatusColor(
                                item.approval_status,
                              ),
                              color: "white",
                              margin: "12px",
                              border: "none",
                            }}
                          >
                            {item.approval_status}
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => nextPage(item.pettycash_id)}
                            style={{
                              height: "30px",
                              width: "38px",
                              backgroundColor: "#5B489D",
                            }}
                          >
                            <SearchIcon
                              className="icon"
                              style={{ color: "white" }}
                            />
                          </button>
                        </td>
                        {/* <td>
                          <a
                            href={item.document_path}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={showDoc} alt="View Document" />
                          </a>
                        </td> */}
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const styles1 = {
  margin: "0px 0 2rem 0px",
  padding: "1px 0 4rem 0",
};

export default PettyCash;
